export const CROP_LIST = 'cropList';
export const CROP_BANNER = 'cropBanner';
export const CROP_DESCRIPTION = 'cropDescription';
export const VARIETY_LIST = 'varietyList';